export const getScreenSize = () => ({
    isMobile: window.innerWidth <= 768,
    isLaptop: window.innerWidth <= 1024,
    size: window.innerWidth,
});
